import React from 'react'
import Wrapper from '../Wrapper'
// import { Link } from 'react-router-dom'
// import { LOGIN_FAILURE_PAGE } from 'utils/constants'

function Dashboard(props) {
  return (
    <>
      <h1 className="text-3xl text-center pt-4">Dashboard</h1>
    </>
  )
}

export default Wrapper(Dashboard)
